<template>
  <div class="page-box">
    <base-screen>
      <a-form-model ref="query" layout="inline" :model="query" @submit.native.prevent @submit="handleQuery">
        <a-form-model-item prop="userName" label="微信昵称">
          <a-input allow-clear v-model="query.userName" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="userPhone" label="手机号">
          <a-input allow-clear v-model="query.userPhone" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button @click="handleReset">重置</a-button>
        </a-form-model-item>
      </a-form-model>
    </base-screen>

    <base-table
      bordered
      :columns="columns"
      :dataSource="data"
      :pagination="page"
      :rowKey="x => x.userAccountId"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #user="ctx">
        <div class="user-card">
          <img v-if="ctx.headImg" :src="ctx.headImg" alt="" />
          <p>{{ctx.userName}}</p>
        </div>
      </template>
      <template #state="ctx">
        <a-tag :color="getStateColor(ctx.state)">{{ getStateText(ctx.state) }}</a-tag>
      </template>
      <template #operation="ctx">
        <a-button v-pms="'charge'" type="link" @click="chargeMoneyFor(ctx)">充值</a-button>
        <a-button v-pms="'charge-voucher'" type="link" @click="chargeVoucherFor(ctx)">充值卡</a-button>
        <a-button type="link" @click="editState(ctx)">修改状态</a-button>
      </template>
    </base-table>

    <a-modal
      v-model="visible"
      :footer="null"
      :keyboard="false"
      :mask-closable="false"
      width="70vw"
    >
      <charge-form
        :key="key"
        :user="user"
        :type="chargeType"
        @close="visible = false"
        @success="getTableData"
      />
    </a-modal>

    <a-modal
      v-model="showStateModal"
      title='修改状态'
      @ok='submitStateChange'
      @cancel='showStateModal = false'
    >
      <a-space direction="vertical" style="width: 100%;">
        <div>
          <strong>当前状态：</strong>
          <a-tag :color="getStateColor(currentRecord && currentRecord.state)">{{ getStateText(currentRecord && currentRecord.state) }}</a-tag>
        </div>
        <div>
          <strong>新状态：</strong>
          <a-radio-group v-model='formState'>
            <a-radio :value="1">正常</a-radio>
            <a-radio :value="-1">禁用</a-radio>
            <a-radio :value="-2">冻结</a-radio>
          </a-radio-group>
        </div>
      </a-space>
    </a-modal>
  </div>
</template>

<script>
import { getSession } from '@/utils/session'
import { SHOPID } from '@/constants'
import { capital } from '@/api'
import ChargeForm from './ChargeForm'

export default {
  name: 'PageCharge',
  components: {
    ChargeForm,
  },
  data () {
    return {
      query: {
        userName: '',
        userPhone: '',
        shopId: getSession(SHOPID),
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      data: [],
      loading: false,
      columns: [
        {
          title: '用户',
          scopedSlots: {
            customRender: 'user'
          }
        },
        {
          title: '手机号',
          dataIndex: 'userPhone'
        },
        {
          title: '余额',
          dataIndex: 'amount'
        },
        {
          title: '状态',
          scopedSlots: {
            customRender: 'state'
          }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          scopedSlots: {
            customRender: 'operation'
          }
        }
      ],
      visible: false,
      key: 0,
      user: null,
      chargeType: '',
      showStateModal: false,
      currentRecord: null,
      formState: 1
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.loading = true
      const res = await capital.getMemberPage({
        ...this.query,
        ...this.page
      })
      this.loading = false
      if (res.code === '00000') {
        this.page.total = res.page.total
        this.data = res.data
      }
    },
    handleQuery () {
      this.page.current = 1
      this.getTableData()
    },
    handleReset () {
      this.$refs.query.resetFields()
      this.handleQuery()
    },
    handleTableChange ({ current }) {
      this.page.current = current
      this.getTableData()
    },
    chargeMoneyFor (data) {
      this.visible = true
      this.user = data
      this.chargeType = 'money'
    },
    chargeVoucherFor (data) {
      this.visible = true
      this.user = data
      this.chargeType = 'voucher'
    },
    editState (data) {
      this.currentRecord = data
      this.formState = data.state
      this.showStateModal = true
    },
    getStateColor (state) {
      const colorMap = {
        1: 'green',
        '-1': 'red',
        '-2': 'orange'
      }
      return colorMap[state] || 'default'
    },
    getStateText (state) {
      const textMap = {
        1: '正常',
        '-1': '禁用',
        '-2': '冻结'
      }
      return textMap[state] || '未知'
    },
    async submitStateChange () {
      try {
        await capital.updateUserAccountState({
          userId: this.currentRecord.userId,
          shopId: getSession(SHOPID),
          state: this.formState
        })
        this.showStateModal = false
        this.getTableData()
      } catch (error) {
        console.error(error)
      }
    }
  },
  watch: {
    visible (value) {
      if (!value) this.key++
    }
  }
}
</script>
